import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    inputTooltip: {
        id: '_.loan_builder.select_amount_with_slider.tooltip',
        defaultMessage: `If you don't take the full {amount} today, you've got until {date} to come back for the rest.`
    }
});
